import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';

export default class CheckboxInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: this.props.checked
    };
  }

  componentWillReceiveProps(newProps) {
    if ('checked' in newProps && newProps.checked !== this.state.isChecked) {
      this.setState({ isChecked: newProps.checked });
    }
  }

  onChange = (e) => {
    this.setState((prevState) => {
      return { isChecked: !prevState.isChecked }
    }, () => {
      if(this.props.onChange) {
        this.props.onChange(e);
      }
    });
  }

  getValue = () => {
    if (this.props.required && !this.state.isChecked) {
      throw new InputError(this.props.label + " is Required", this.state.isChecked);
    }

    return this.state.isChecked;
  }

  render() {
    let checkbox = (
      <input
        id={this.props.id}
        className={this.props.className}
        type="checkbox"
        name={this.props.name}
        value={this.props.value}
        onChange={(e) => {
          e.persist();
          this.onChange(e);
        }}
        required={this.props.required}
        disabled={this.props.disabled}
        checked={this.state.isChecked}
      />
    );

    let legend = (this.props.legend)
      ? <label className="legend" htmlFor={this.props.id}>
          {this.props.legend}
        </label>
      : null;

    let label = (<label htmlFor={this.props.id}>{this.props.label}</label>);

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let errorMessage = (this.props.errorMessage)
      ? <span className="error-message">
          {this.props.errorMessage}
        </span>
      : null;

    const requiredFieldIndicator = (this.props.required) ? <abbr title="This field is required">*</abbr> : null;

    if (!this.props.isEditable) {
      let checkedContent = (this.props.checked) ?
        this.props.label :
        null;


      return (
        <div className={verticalSpacingClass}>
          {legend}
          <div className="read-only">
            {checkedContent}
          </div>
        </div>
      )
    }
    else {
      return (
        <div className={verticalSpacingClass}>
          {legend}
          {checkbox}{requiredFieldIndicator}{label}
          {errorMessage}
        </div>
      );
    }
  }
}

CheckboxInput.defaultProps = {
  checked: false,
  isEditable: true,
  required: false
};

CheckboxInput.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  legend: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
  verticalSpacing: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/checkbox-input/CheckboxInput.js